<!--
 * @Author: FengXiao
 * @Date: 2026-05-18 00:00:00
 * @LastEditors: FengXiao
 * @LastEditTime: 2026-05-18 00:00:00
-->
<template>
  <div class="tab-event-page content page-container">
    <div class="event-list">
      <div class="event-item" v-for="item in events" :key="item.id" @click="gotoDetail(item)">
        <div class="event_cover">
          <img class="event_cover-img" :src="item.cover_url || item.cover" :alt="item.title" srcset="" />
        </div>
        <div class="event_info">
          <div class="event_title">{{ item.title }}</div>
          <div class="address-wrap">
            <span class="address">{{ item.event_city || item.city }}</span>
            <span class="time" v-if="item.start_time">
              {{ getFormattedTime(item) }}
            </span>
          </div>
          <div class="event_address" v-if="item.event_address || item.address">
            {{ item.event_address || item.address }}
          </div>
          <div class="event_tags">
            <span class="event_tag recommended" v-if="+item.recommended">推荐</span>
            <span class="event_tag cost" v-if="+item.cost">付费</span>
            <span class="event_tag free" v-else>免费</span>
            <span class="event_tag status preview" v-if="+item.status === 1">预告</span>
            <span class="event_tag status selling" v-if="+item.status === 2">售票中</span>
            <span class="event_tag status active" v-if="+item.status === 3">活动中</span>
            <span class="event_tag status ended" v-if="+item.status === 4">已结束</span>
          </div>
          <div class="event_stats">
            <span v-if="item.view_count">浏览 {{ item.view_count }}</span>
            <span v-if="item.likes_count">喜欢 {{ item.likes_count }}</span>
          </div>
          <div class="event_organization" v-if="item.organization">
            <div class="organizer-mini-card">
              <img v-if="item.organization.avatar_url" :src="item.organization.avatar_url" class="organizer-mini-logo">
              <div class="organizer-mini-info">
                <span class="organizer-mini-name">{{ item.organization.name }}</span>
                <span class="certified-badge-mini" v-if="item.organization.certify_status == 1">
                  <i class="iconfont iconrenzheng"></i>
                </span>
              </div>
            </div>
          </div>
          <div class="immediately_btn" v-if="shouldShowButton(item)">
            <div class="goupiaobtn" :class="{ 'shouqing': !canClickButton(item) }" @click.stop="handleAction(item)">
              {{ +item.cost === 0 ? '打开一席小程序报名' : '打开一席小程序购票' }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="load_more_btn" v-show="!isLoadedAll" @click="loadMore">加载更多</div>
  </div>
</template>

<script>
import requestApi from '@/service';

export default {
  name: 'Event',
  data() {
    return {
      events: [],
      pageNum: 1,
      pageSize: 5,
      total: 0,
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.path !== '/event/detail' || !vm.events.length) {
        vm.refreshData();
        vm.initScrollTop();
      }
    });
  },
  computed: {
    isLoadedAll() {
      return this.total / this.pageSize <= this.pageNum;
    },
  },
  methods: {
    refreshData() {
      this.pageNum = 1;
      this.events = [];
      this.getData();
    },
    getData() {
      requestApi('/v3/api/site/event/extend/', {
        page: this.pageNum,
        page_size: this.pageSize,
      }).then(res => {
        const items = res.items || res.data || [];
        if (this.pageNum === 1) {
          this.events = items;
          this.total = res.total || res.count || items.length;
        } else {
          this.events = this.events.concat(items);
        }
      });
    },
    loadMore() {
      if (!this.isLoadedAll) {
        this.pageNum += 1;
        this.getData();
      }
    },
    gotoDetail(data) {
      this.$router.push({
        path: '/event/detail',
        query: {
          id: data.id,
        },
      });
    },
    handleAction(item) {
      // 只有可点击时才执行跳转
      if (this.canClickButton(item)) {
        // 隐私改版：报名涉及收集用户信息，免费/付费统一引导打开一席小程序
        this.gotoLogin();
      }
    },
    shouldShowButton(item) {
      const isFree = +item.cost === 0;
      const status = +item.status;
      
      if (isFree) {
        // 免费活动：预告(1)和售票中(2)显示按钮
        return status === 1 || status === 2;
      } else {
        // 收费活动：只有售票中(2)显示按钮
        return status === 2;
      }
    },
    canClickButton(item) {
      const isFree = +item.cost === 0;
      const status = +item.status;
      
      if (isFree) {
        // 免费活动：预告(1)和售票中(2)都可点击
        return status === 1 || status === 2;
      } else {
        // 收费活动：只有售票中(2)可点击
        return status === 2;
      }
    },
    // 判断两个时间是否在同一天
    isSameDay(startTime, endTime) {
      if (!startTime || !endTime) return false;
      const start = new Date(startTime);
      const end = new Date(endTime);
      return (
        start.getFullYear() === end.getFullYear() &&
        start.getMonth() === end.getMonth() &&
        start.getDate() === end.getDate()
      );
    },
    // 格式化日期时间显示：MM-DD 周X HH:mm
    formatDateTimeDisplay(timeStr) {
      if (!timeStr) return '';
      const date = new Date(timeStr);
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const weekDays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
      const weekDay = weekDays[date.getDay()];
      return `${month}-${day} ${weekDay} ${hours}:${minutes}`;
    },
    // 只格式化时间部分：HH:mm
    formatTimeOnly(timeStr) {
      if (!timeStr) return '';
      const date = new Date(timeStr);
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${hours}:${minutes}`;
    },
    // 获取格式化后的时间显示文本
    getFormattedTime(item) {
      if (!item.start_time) return '';
      
      // 如果有结束时间
      if (item.end_time) {
        if (this.isSameDay(item.start_time, item.end_time)) {
          // 同一天：05-20 周三 14:00 - 15:00
          return `${this.formatDateTimeDisplay(item.start_time)} - ${this.formatTimeOnly(item.end_time)}`;
        } else {
          // 不同天：05-20 周三 14:00 至 05-21 周四 15:00
          return `${this.formatDateTimeDisplay(item.start_time)} 至 ${this.formatDateTimeDisplay(item.end_time)}`;
        }
      }
      
      // 只有开始时间
      return this.formatDateTimeDisplay(item.start_time);
    },
  },
};
</script>

<style lang="scss" scoped>
.event-list {
  .event-item {
    width: 100%;
    background: $C1;
    display: flex;
    margin: 40px 0;
    cursor: pointer;
    border: 1px solid $C11;
    .event_cover {
      width: 490px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .event_info {
      flex: 1;
      position: relative;
      padding: 20px;
      padding-right: 100px; /* 预留按钮空间，防止文字重叠 */
      max-width: calc(100% - 490px);
      box-sizing: border-box;
      .event_title {
        font-family: HYXinRenWenSongW;
        font-size: 18px;
        line-height: 20px;
        margin-bottom: 10px;
      }
      .address-wrap {
        font-size: 14px;
        color: $C9;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 10px;
        margin-bottom: 8px;
        .address,
        .time {
          font-family: HYXinRenWenSongW;
        }
      }
      .event_address {
        color: $C9;
        font-size: 14px;
        margin-bottom: 10px;
      }
      .event_tags {
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
        margin-bottom: 12px;
        .event_tag {
          display: inline-flex;
          align-items: center;
          padding: 0 8px;
          height: 24px;
          line-height: 24px;
          border-radius: 12px;
          font-size: 12px;
          background: rgba(0, 0, 0, 0.05);
          color: $C9;
          &.recommended {
            background: $C2;
            color: #fff;
          }
          &.cost {
            background: #f5a623;
            color: #fff;
          }
          &.free {
            background: #2ecc71;
            color: #fff;
          }
          &.status {
            background: $C11;
            color: $C3;
            &.preview {
              background: #7b8a8f;
              color: #fff;
            }
            &.selling {
              background: #ff6b35;
              color: #fff;
            }
            &.active {
              background: #2ecc71;
              color: #fff;
            }
            &.ended {
              background: $C11;
              color: $C3;
            }
          }
        }
      }
      .event_intro {
        color: $C3;
        font-size: 14px;
        font-weight: 400;
        margin-top: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        line-clamp: 3;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
      .event_stats {
        margin-top: 14px;
        font-size: 12px;
        color: $C9;
        span + span {
          margin-left: 16px;
        }
      }
      .event_organization {
        margin-top: 12px;
        .organizer-mini-card {
          display: inline-flex;
          align-items: center;
          padding: 6px 12px;
          background: rgba(0, 0, 0, 0.03);
          border-radius: 16px;
          .organizer-mini-logo {
            width: 24px;
            height: 24px;
            border-radius: 50%;
            object-fit: cover;
            margin-right: 8px;
          }
          .organizer-mini-info {
            display: flex;
            align-items: center;
            gap: 6px;
            .organizer-mini-name {
              font-size: 13px;
              color: $C13;
            }
            .certified-badge-mini {
              display: inline-flex;
              align-items: center;
              color: #ff6b35;
              font-size: 12px;
              i {
                font-size: 12px;
              }
            }
          }
        }
      }
      .immediately_btn {
        position: absolute;
        bottom: 20px;
        right: 20px;
        z-index: 10;
        .goupiaobtn {
          padding: 8px 20px;
          background: $C2;
          color: #fff;
          border-radius: 20px;
          font-size: 14px;
          cursor: pointer;
          transition: all 0.3s;
          &.shouqing {
            background: $C11;
            color: $C9;
            cursor: not-allowed;
          }
          &:not(.shouqing):hover {
            opacity: 0.9;
          }
        }
      }
    }
  }
}
</style>
